(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* =========================================================
     SDB FIX (MOBILE): Hard-stop Dawn "panel navigation" in drawer
     We intercept summary clicks and run our own accordion toggles.
     This prevents the main menu disappearing / blank panels.
     ========================================================= */
  document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.getElementById('menu-drawer');
    if (!drawer) return;

    const mq = window.matchMedia('(max-width: 989px)');

    const forceRootVisible = () => {
      drawer.querySelectorAll('.menu-drawer__menu[hidden]').forEach((el) => el.removeAttribute('hidden'));
      drawer.querySelectorAll('.menu-drawer__submenu[hidden]').forEach((el) => el.removeAttribute('hidden'));
    };

    const closeAllSubmenus = () => {
      drawer.querySelectorAll('details[open]').forEach((d) => d.removeAttribute('open'));
      drawer.querySelectorAll('details.menu-opening').forEach((d) => d.classList.remove('menu-opening'));
      forceRootVisible();
    };

    const bindAccordion = () => {
      if (!mq.matches) return;

      // When drawer opens, always reset to root (no stuck submenu)
      const container = drawer.closest('details');
      if (container && !container.dataset.sdbBound) {
        container.dataset.sdbBound = '1';
        container.addEventListener('toggle', () => {
          if (container.open) closeAllSubmenus();
        });
      }

      // Intercept clicks on menu summaries that have a submenu
      drawer.querySelectorAll('summary').forEach((summary) => {
        if (summary.dataset.sdbBound) return;

        const details = summary.parentElement;
        if (!details || details.tagName.toLowerCase() !== 'details') return;

        const submenu = details.querySelector('.menu-drawer__submenu');
        if (!submenu) return; // regular links shouldn't be touched

        summary.dataset.sdbBound = '1';

        summary.addEventListener(
          'click',
          (e) => {
            if (!mq.matches) return;

            // Stop Dawn's panel-navigation logic
            e.preventDefault();
            e.stopImmediatePropagation();

            // Close siblings (optional: makes it neat like Hyderliving)
            const siblings = Array.from(details.parentElement.querySelectorAll(':scope > details[open]')).filter(
              (d) => d !== details
            );
            siblings.forEach((d) => d.removeAttribute('open'));

            // Toggle this one
            if (details.hasAttribute('open')) details.removeAttribute('open');
            else details.setAttribute('open', '');

            // Ensure root menu never disappears
            forceRootVisible();
          },
          true // CAPTURE is important to beat Dawn’s listeners
        );
      });

      forceRootVisible();
    };

    bindAccordion();
    mq.addEventListener('change', bindAccordion);
  });

  } catch(e) { console.error(e); }
})();
})();
